import { render } from "./Steps4.vue?vue&type=template&id=7f1184f1"
import script from "./Steps4.vue?vue&type=script&lang=js"
export * from "./Steps4.vue?vue&type=script&lang=js"
script.render = render

export default script